import React from 'react';
import clsx from 'clsx';
import Depot from '../../_shared/depot';
import * as styles from './style.module.css';
import typeSizes from '../../Typography/shared/typeSizes/typeSizes';
import fontWeights from '../../Typography/shared/fontWeights/fontWeights';
export const textButtonTypes = ['default', 'inline'];
const TextButtonWithoutRef = ({ text, className, buttonType = 'default', typeSize = 'body', fontWeight = 'bold', disabled = false, icon: PassedIcon, alignIcon = 'leading', sidePadding = true, type = 'button', onClick, ...commonProps }) => {
    const isInline = buttonType === 'inline';
    const buttonClasses = clsx(className, styles.root, {
        [styles.inline]: isInline,
        [styles.removeSidePadding]: !sidePadding,
    });
    const iconClasses = clsx(styles.icon);
    let textSidePaddingRemovalClass;
    if (!sidePadding) {
        if (!PassedIcon) {
            textSidePaddingRemovalClass = styles.removeSidePadding;
        }
        else {
            // we still require padding-left if the icon is on the left and vice versa
            textSidePaddingRemovalClass =
                alignIcon === 'leading'
                    ? styles.removePaddingRight
                    : styles.removePaddingLeft;
        }
    }
    const spanClasses = clsx(styles.text, isInline && styles.inlineText, typeSizes[typeSize], fontWeights[fontWeight], textSidePaddingRemovalClass);
    return Depot.createElement('button', {
        className: buttonClasses,
        type,
        onClick: (e) => {
            if (onClick && !disabled) {
                onClick(e);
            }
        },
        ['aria-disabled']: disabled,
        ...commonProps,
    }, React.createElement(React.Fragment, null,
        PassedIcon && alignIcon === 'leading' && (React.createElement(PassedIcon, { className: iconClasses, size: 24 })),
        React.createElement("span", { className: spanClasses }, text),
        PassedIcon && alignIcon === 'trailing' && (React.createElement(PassedIcon, { className: iconClasses, size: 24 }))));
};
const TextButton = Depot.withRef(TextButtonWithoutRef);
TextButton.displayName = 'TextButton';
export default TextButton;
//# sourceMappingURL=index.js.map